export default {
  props: ['item', 'index', 'currency', 'data_id', 'show_nightstand_upsell'],
  store: window.store,
  computed: {
    finalPrice() {
      return `$${((this.item.line_price) / 100.0).toFixed(2)}`
    },
    compareAtPrice() {
      let compareAtPrice = (Number(this.item.properties?._compare_at_price)) ? Number(this.item.properties?._compare_at_price) : Number(this.item.discounted_price)
      return compareAtPrice
    },
    isOneTimeProduct() {
      return this.item.handle === 'gift-note' || 
      this.item.handle === 'gifting-ship-loftie-in-an-overbox' || 
      this.item.handle === 'shipping-protection';
    },
    imageHref() {
      if (this.item.price > 1) {
        return !this.isOneTimeProduct ? this.item.url : null;
      }
      return null;
    }
  },
  methods: {
    formatPrice(num) {
      return `$${(parseFloat(num) / 100.0).toFixed(2)}`
    },
    addVariantClass() {
      return `variant_${this.item.variant_id}`
    },
    visibilityNone(item) {
      //Used for the weekend sale to hide + / - buttons in cart pullout
      if(item.properties && item.properties._Free === "weekend-sale") return 'invisible';
      if(item.properties && item.properties._Free === "coffee-clock-gift") return 'invisible';
      return '';
    },
    async decrement() {

      let updates = {
        "id": this.item.key.toString(),
        "quantity": (this.item.quantity - 1).toString()
      }

      // add freegiftRemoved to Local Storage
      if(this.item.properties?.message && updates.quantity === 0) { localStorage.setItem('freeGiftRemoved', true)}

      const response = await fetch(`/cart/change.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      });
      const cart = await response.json();

      return 
    },
    checkAndIncrement(item) {
      if (item.handle !== 'gift-note' && item.handle !== 'gifting-ship-loftie-in-an-overbox' && item.handle != 'shipping-protection') {
        this.increment();
      }
    },
    async increment() {
      let updates = {
        "id": this.item.key.toString(),
        "quantity": (this.item.quantity + 1).toString()
      }

      const response = await fetch(`/cart/change.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      });
      const cart = await response.json();

      return 
    },
    async updateItemQuantity(value) {
      let updates = {
        "id":  this.item.variant_id.toString(),
        "quantity": value.toString()
      }

      const response = await fetch(`/cart/change.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      });
      const cart = await response.json();

      return 
    },
    async removeAndReplace() {
      let updates = {
        updates:{}
      }
      updates.updates[this.item.variant_id.toString()] = 0;
      updates.updates[store.getters.replacedVariantId.toString()] = 1;

      // add freegiftRemoved to Local Storage
        if(this.item.properties?.message) { localStorage.setItem('freeGiftRemoved', true)}

      const response = await fetch(`/cart/update.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      });
      const cart = await response.json();

      localStorage.removeItem('replacedVariantId');

      return 
    },
    async remove(id) {
      //id is unused unless we have a sale on

      let updates = {
        updates:{}
      }
      updates.updates[this.item.key.toString()] = 0;

      // add freegiftRemoved to Local Storage
      // Not sure what this first one is for...
      if(this.item.properties?.message) { localStorage.setItem('freeGiftRemoved', true)}

      // This one is for the free gift that is set in the theme settings
      if(this.item.properties?._Free == 'weekend-sale') { localStorage.setItem('giftRemoved', true)}

      // This one is for the free gift that is given when the user buys a coffee clock
      if(id === 45123428548855) { localStorage.setItem('coffeeClockGiftRemoved', true)}


      const response = await fetch(`/cart/update.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      });
      const cart = await response.json();

      return 
    }
  },
    template: `

    <div class="line-item__content-wrapper" v-if="item.variant_id != 44191634292983">
    <div class="image">
      <a :href="imageHref" class="line-item__image-wrapper" tabindex="-1" aria-hidden="true">
        <img :src="item.image + '&width=300'" class="line-item__image" loading="sizes" sizes="(max-width: 200px) 92px, 160px, 276px">
      </a>
    </div>
    <div class="line-item__info">
      <a :href="imageHref" class="product-item-meta__title text--small">{{ item.product_title }} &nbsp; <span v-if="item.discounted_price == 0  && item.properties['Free']">x{{item.quantity}}</span></a>
      <div class="product-item-meta__property-list">

      <!-- Extend - display Extend line item properties-->
      <span v-if="item.vendor == 'Extend'"
        class="product-item-meta__property text--subdued text--xsmall">Product: {{ item.properties.Product }}</span>
      <span v-if="item.vendor == 'Extend'"
        class="product-item-meta__property text--subdued text--xsmall">Term: {{ item.properties.Term }}</span>
      <!-- Extend - end Extend code -->

      <span v-if="item.vendor != 'Extend'" class="product-item-meta__property text--subdued text--xsmall">{{ item.variant_title }}</span>
      </div>
      <span v-if="item.properties && item.properties.message"
        class="product-item-meta__property text--subdued text--xsmall">{{ item.properties.message }}</span>
              <span v-if="item.selling_plan_allocation"
        class="product-item-selling_plan text--subdued text--xsmall">{{ item.selling_plan_allocation.selling_plan.name }}</span>
      <template v-if="item.discounts">
        <ul class="line-item__discount-list list--unstyled" role="list" v-for="discount in item.discounts">
          <li class="line-item__discount-badge discount-badge">
            <svg focusable="false" width="10" height="10" class="icon icon--discount-badge   " viewBox="0 0 10 10">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.93734 1.1171C9.97075 0.521457 9.47854 0.0292498 8.88291 0.0626607L5.39562 0.258271C5.15016 0.27204 4.91836 0.375751 4.74452 0.549595L0.707107 4.58701C0.316582 4.97753 0.316583 5.6107 0.707107 6.00122L3.99878 9.29289C4.3893 9.68342 5.02247 9.68342 5.41299 9.29289L9.4504 5.25548C9.62425 5.08163 9.72796 4.84984 9.74173 4.60438L9.93734 1.1171ZM7.05882 2.94118C7.3837 3.26605 7.91042 3.26605 8.23529 2.94118C8.56017 2.6163 8.56017 2.08958 8.23529 1.76471C7.91042 1.43983 7.3837 1.43983 7.05882 1.76471C6.73395 2.08958 6.73395 2.6163 7.05882 2.94118Z" fill="currentColor"></path>
            </svg>{{discount.title}} 
          </li>
        </ul>
      </template>

      <!-- For if there's one lamp in the cart. Hidden on request by client for now <span v-if="item.product_id == 7588884840695 && item.quantity == 1" class="product-item-meta__property text--subdued text--xsmall upsell-message">MAKE IT TWO FOR $50 OFF</span> -->
      <div v-if="item.price > 1" class="line-item__quantity">
        <div class="quantity-selector quantity-selector--small" :class="item.variant_id == 43919100313847 ? 'hide' : ''">
          <span :class="[addVariantClass(), visibilityNone(item)]" class="quantity-selector__button" @click="decrement">-</span>
          <input class="quantity-selector__input text--xsmall" @change="event => updateItemQuantity(event.target.value)" :value="item.quantity" :disabled="isOneTimeProduct" />
          <span :class="visibilityNone(item)" class="quantity-selector__button" @click="checkAndIncrement(item)">+</span>
        </div>
      </div>
    </div>
    <div class="price_and_remove">
      <div class="product-item-meta__price-list-container text--small">

        <template v-if="item.properties?._Free || (item.id == 43919100313847 && item.price == item.total_discount)">
          <div class="price-list">
            <span class="price price--highlight">
              FREE
            </span>
            <span class="price price--compare test">
              {{formatPrice(item.original_price)}}
          </span>
          </div>
        </template>

        <template v-else-if="compareAtPrice > item.discounted_price">
          <div class="price-list">
            <span class="price price--highlight">
              <span>$</span>{{((item.discounted_price * item.quantity) / 100.00).toFixed(2)}}
            </span>
            <span class="price price--compare">
              {{formatPrice(compareAtPrice)}}
            </span>
          </div>
        </template>
        <template v-else-if="item.line_price < item.original_line_price">
        <div class="price-list">
          <span class="price price--highlight">
            <span>$</span>{{((item.discounted_price * item.quantity) / 100.00).toFixed(2)}}
          </span>
          <span class="price price--compare">
            {{formatPrice(item.original_line_price)}}
          </span>
        </div>
      </template>
        <template v-else>
          <div class="price-list">
            <span class="price price--highlight">
              {{finalPrice == '$0.00' ? 'FREE' : finalPrice}}
            </span>
          </div>
        </template>

      </div>
      <span v-if="show_nightstand_upsell" class="line-item__remove-button link text--subdued text--xxsmall" @click="data_id === 7828235092215 ? removeAndReplace() : remove(item.id)">Remove</span>
      <span v-else class="line-item__remove-button link text--subdued text--xxsmall" @click="remove(item.id)">Remove</span>
    </div>
  </div>
  `
}

